import { mixinAuthn } from "@okta/okta-auth-js";
import { OktaAuth as OktaAuth$1 } from "./oie.js";
const OktaAuth = mixinAuthn(OktaAuth$1);
export { OktaAuth };
